import { useState } from 'react';

const painPoints = [
  {
    icon: 'ri-alert-line',
    title: '数据穿透一来，最怕要补税',
    description: '把对不上的那几笔先揪出来——平台流水 × 收款 × 报关 × 开票自动对齐，差一分都标红留痕；你在被问之前就能补齐证据，把"解释"变成"证明"，把补税风险压下去。',
    gradient: 'from-red-500 to-red-600',
    example: '查看对齐报告示例'
  },
  {
    icon: 'ri-file-shield-2-line',
    title: '9810预退税容易，核销很难',
    description: '预退只是开始,核销才是生死线——系统按票固化"单单对应关系"（订单/出库/物流/收款/报关/发票），缺什么、卡哪里一眼就懂；材料不再靠人肉翻箱倒柜，核销从"碰运气"变成"按清单过关"。',
    gradient: 'from-orange-500 to-orange-600',
    example: '查看核销清单示例'
  },
  {
    icon: 'ri-archive-line',
    title: '单证管得住，账就算得清',
    description: '单证一乱，账就一定糊；账一糊，利润就是假——系统把单证做成一键归档包 + 可追溯目录，同一票的关键材料随叫随到；账务按口径自动落到批次/票号，每一笔收入成本税费都"拿得出、说得清、经得起查"。',
    gradient: 'from-[#14B8A6] to-[#0D9488]',
    example: '查看归档包示例'
  }
];

export default function PainPoints() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const openExampleModal = (index: number) => {
    const modal = document.getElementById('example-modal');
    const tabButtons = modal?.querySelectorAll('[data-tab]');
    if (modal && tabButtons) {
      modal.classList.remove('hidden');
      (tabButtons[index] as HTMLElement)?.click();
    }
  };

  return (
    <section id="features" className="py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-4">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            一套系统解决三大痛点
          </h2>
          <div className="w-12 h-1 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] mx-auto rounded-full"></div>
        </div>

        <p className="text-center text-gray-600 text-lg mb-16 font-medium">
          合规不是多做事，是少背锅：少补税、少返工、少扯皮。
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {painPoints.map((point, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className={`bg-white rounded-3xl p-10 transition-all duration-300 cursor-pointer ${
                hoveredIndex === index ? 'shadow-2xl -translate-y-2' : 'shadow-lg'
              }`}
            >
              <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${point.gradient} flex items-center justify-center mb-6`}>
                <i className={`${point.icon} text-3xl text-white`}></i>
              </div>

              <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                {point.title}
              </h3>

              <p className="text-gray-600 leading-relaxed mb-6">
                {point.description}
              </p>

              <button
                onClick={() => openExampleModal(index)}
                className="text-sm text-[#14B8A6] font-medium flex items-center gap-2 group cursor-pointer hover:gap-3 transition-all whitespace-nowrap"
              >
                {point.example}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
